import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'

import { Link } from "react-router-dom";
import Icon from '../compUtils/Icon';


function ObjectSearch(props) {

    const dispatch = useDispatch()

    const objectsId = props.url
    const objectsSelector = useObjectSelector(objectsId)
    const objects = getObject(objectsId, objectsSelector, dispatch)

    const [searchString, setSearchString] = useState('')

    const changeName = (event) => {
        setSearchString(event.target.value)
    }

    const [dropdownSearch, setDropdownSearch] = useState({ dropped: false, list: [] })

    useEffect(() => {
        if (searchString === '') {
            setDropdownSearch({ dropped: false, list: [] })
            return
        }
        if (objects() === 'UNKNOWN') return
        const filteredObjects = objects().filter(object => object.name.toUpperCase().startsWith(searchString.toUpperCase()))
        setDropdownSearch({ dropped: true, list: filteredObjects })
    }, [searchString]);


    return (
        <div class="dropdown is-active">
            <div class="dropdown-trigger">
                <div class="field">
                    <p class="control is-expanded has-icons-right">
                        <input class="input" type="search" placeholder="Search..." onChange={changeName} />
                        <span class="icon is-small is-right"><Icon name="search" /></span>
                    </p>
                </div>
            </div>

            {dropdownSearch.dropped ?
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        {dropdownSearch.list.map((object) => (
                            <div class="dropdown-item"><a href="#" onClick={() => { setDropdownSearch({ dropped: false, list: [] }) ; props.selectCallback({"id":object.id,"name":object.name})}}>{object.name}</a></div>
                        ))}
                    </div>
                </div>
                :
                ""
            }
        </div>

    );
}

export default ObjectSearch;
